module.exports = __webpack_public_path__ + "static/media/Master-Logo.ea851cb8.svg";